// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cntTransferPayment th {\n  width: 30% !important;\n}", "",{"version":3,"sources":["webpack://./app/javascript/components/polizas/nueva_poliza/transferPayment.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ","sourcesContent":[".cntTransferPayment {\n  th {\n    width: 30% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
